_ = require 'underscore'
Controller = require 'controller'
l = require 'lib/localize'
Enterprise = require 'models/enterprise'
Payloads = require 'network/payloads'
Promise = require 'bluebird'
View = require 'view'
log = require 'debug/log'
template = require 'views/templates/header_enterprise_admin_dashboard_menu'
t = require('views/internal/teacup-with-helpers')('header_enterprise_admin_dashboard_menu')

empty = t.renderable ->
  t.format 'no-enterprises'

loading = t.renderable ->
  t.format 'loading'

module.exports = class HeaderEnterpriseAdminDashboardMenuView extends View
  getViewTitle: -> l ['view title', 'trello enterprise']

  initialize: ->
    Promise.map @model.get('idEnterprisesAdmin'), (id) =>
      Enterprise.load id, Payloads.enterpriseMinimum, @modelCache
    .then (result) =>
      @enterprises = result
      @render()

  render: ->
    log('render', "rendering HeaderEnterpriseAdminDashboardMenuView")

    if @enterprises?
      if @enterprises.length > 0
        links = _.map @enterprises, (e) =>
          title: e.get('displayName')
          url: Controller.getEnterpriseAdminDashboardUrl e.get('name')
        @$el.html template links
      else
        @$el.text empty()
    else
      @$el.text loading()

    @



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-enterprise-admin-dashboard-menu-view.coffee